export default {
    common: {
        done: "Done",
        duplicate: "Duplicate",
        loading: "Loading...",
        loadingProducts: "Loading products...",
        loadingPostalCodes: "Loading postal codes...",
        loadingRestaurantData: "Loading restaurant data...",
        all: "All",
        save: "Save",
        saving: "Saving...",
        cancel: "Cancel",
        delete: "Delete",
        deleting: "Deleting...",
        edit: "Edit",
        add: "Add",
        search: "Search",
        filter: "Filter",
        reset: "Reset",
        confirm: "Confirm",
        confirmation: "Confirmation",
        close: "Close",
        refresh: "Refresh",
        back: "Back",
        next: "Next",
        previous: "Previous",
        first: "First",
        last: "Last",
        submit: "Submit",
        yes: "Yes",
        no: "No",
        actions: "Actions",
        status: "Status",
        date: "Date",
        time: "Time",
        minutes: "minutes",
        name: "Name",
        description: "Description",
        price: "Price",
        quantity: "Quantity",
        total: "Total",
        language: "Language",
        customer: "Customer",
        company: "Company",
        view: "View",
        page: "Page",
        update: "Update",
        paymentStatus: "Payment Status",
        more: "More",
        seeLess: "See Less",
        create: "Create",
        title: "Title",
        message: "Message",
    },
    header: {
        profile: "My Account",
        myRestaurant: "My Restaurant",
        changePassword: "Change Password",
        logout: "Logout",
        administrator: "Administrator",
        restaurant: "Restaurant",
    },
    roles: {
        administrator: "ADMINISTRATOR",
        user: "USER",
        franchise: "FRANCHISE",
        restaurant: "RESTAURANT",
        technicalSupport: "TECHNICAL SUPPORT",
        guest: "CLIENT",
    },
    sidebar: {
        dashboard: "Dashboard",
        pos: "POS",
        posSystem: "POS System",
        sales: "Sales",
        orders: "Orders",
        transactions: "Transactions",
        salesReport: "Sales Report",
        management: "Management",
        timeSlots: "Time Slots",
        deliveryZones: "Delivery Zones",
        products: "Products",
        categories: "Categories",
        ingredients: "Ingredients",
        ingredientTypes: "Ingredient Types",
        managmentCategories: "Ingredient Category Management",
        supplements: "Supplements",
        supplementTypes: "Supplement Types",
        features: "Features",
        ingredientBases: "Base Ingredients",
        campaigns: "Campaigns",
        emailCampaigns: "E-mail Campaigns",
        pushNotifications: "Push Notifications",
        programs: "Referral & Loyalty",
        customers: "Customers",
        users: "Users",
        userList: "User List",
        restaurants: "Restaurants",
        restaurantList: "Restaurant List",
        franchises: "Franchises",
        accounts: "Accounts",
        coupon: "Coupon",
        openingHours: "Opening Hours",
        paymentMethods: "Payment Methods",
        logout: "Logout",
        referral: "Programs",
        loyalty: "Loyalty & Referral",
        automatedMessages: "Automated Messages",
        advancedAnalytics: "Advanced Analytics",
        closures: "Special Closures",
        loyaltyReport: "Loyalty Report",
        giftCards: "Gift Cards",
    },
    order: {
        orders: "Order(s)",
        removed: "Removed",
        noOrders: "No orders found.",
        orderDetails: "Order Details",
        createDate: "Created on:",
        pickupDate: "Pickup Date:",
        paymentMethod: "Payment Method:",
        orderType: "Order Type:",
        notSpecified: "Not specified",
        immediately: "IMMEDIATELY",
        customer: "Customer",
        customerInfo: "Customer Information",
        deliveryAddress: "Delivery Address",
        orderItems: "Order Items",
        productList: "Product List",
        subtotal: "Subtotal",
        deliveryFee: "Delivery Fee",
        discount: "Discount",
        tax: "Tax",
        grandTotal: "Grand Total",
        orderStatus: "Order Status",
        notes: "Notes",
        invoice: "Invoice & Referral",
        invoiceNumber: "Invoice:",
        coupon: "Coupon:",
        civility: "Civility:",
        customerType: "Customer Type:",
        company: "Company",
        classic: "Classic",
        fullName: "Full Name:",
        email: "E-mail:",
        phoneNumber: "Phone Number",
        quantity: "Quantity",
        total: "Total",
        ingredients: "Ingredients",
        supplements: "Supplements",
        noSupplements: "No Supplements",
        supplementName: "SUPPLEMENT NAME",
        ingredientName: "INGREDIENT NAME",
        type: "TYPE",
        price: "PRICE",
        description: "DESCRIPTION",
        orderNote: "Order Note",
        orderId: "Order ID-",
        estimatedDeliveryTime: "Estimated delivery time",
        customerInstruction: "Customer instruction",
        orderSummary: "Order Summary",
        includingVat: "INCLUDING VAT (2.60%)",
        includingVatDynamic: "INCLUDING VAT ({rate}%)",
        additionalFees: "ADDITIONAL FEES",
        noIngredients: "No Ingredients",
        unknownProduct: "Unknown Product",
        noCategory: "No Category",
        yes: "Yes",
        no: "No",
        free: "Free",
        paid: "Paid",
        shouldSlice: "Should we slice",
        paymentAddress: "Billing Address",
        street: "Street",
        number: "No.",
        postalCode: "Postal Code",
        locality: "Locality",
        phone: "Phone",
        totalGross: "GROSS TOTAL",
        vat: "2.60% VAT",
        productName: "PRODUCT NAME",
        productPrice: "PRODUCT PRICE",
        paymentStatus: "Payment Status",
        paymentMethodTitle: "Payment Method",
        paymentMethods: {
            payClickCollectCash: "Cash Payment",
            payClickCollectCarte: "Card Payment",
            payDeliveryCash: "Cash on Delivery",
            payDeliveryCarte: "Card on Delivery",
            online: "Online Payment (Walle)",
        },
        orderTypes: {
            delivery: "Delivery",
            clickCollect: "Takeaway",
            dineIn: "Dine In",
        },
        status: {
            pending: "Pending",
            processing: "Processing",
            readyForDelivery: "Ready for delivery",
            outForDelivery: "Out for delivery",
            delivered: "Delivered",
            cancelled: "Cancelled",
        },
        preOrder: "PRE-ORDER",
        rightAway: "RIGHT AWAY",
        products: "products",
        netTotal: "Net total",
        viewDetails: "View details",
        viewPdf: "View PDF",
        noOrdersAvailable: "No orders available.",
        unknown: "Unknown",
        transactionReference: "Transaction Reference",
        pdf: "PDF",
    },
    product: {
        addProduct: "Add Product",
        editProduct: "Edit Product",
        productName: "Product Name",
        productDescription: "Product Description",
        productPrice: "Product Price",
        productCategory: "Product Category",
        productImage: "Product Image",
        nutritionalValues: "Notes & Nutritional Values",
        multilingualTranslations: "Multilingual Translations",
        complete: "Complete",
        incomplete: "Incomplete",
        giveNote: "Give a note and nutritional value",
        type: "Type",
        category: "Category",
        restaurant: "Restaurant",
        positioning: "Positioning",
        image: "Image",
        uploadFile: "Upload file",
        httpsLink: "HTTPS Link",
        acceptedFormats: "Accepted formats: JPEG, PNG, WebP (max 2 MB)",
        enterValidHttpsUrl: "Enter a valid HTTPS URL to an image",
        productVariation: "Product variation (Specify different sizes)",
        updateVariation: "Update variation",
        addVariation: "Add a variation",
        sizes: "size(s)",
        noSize: "No size",
        specifyProductSizes: "Specify the different sizes of the product",
        size: "Size",
        takeawayPrice: "Takeaway Price",
        deliveryPriceLabel: "Delivery Price",
        specificSizeDescription: "Description specific to this size",
        add: "Add",
        validate: "Validate",
        remove: "Remove",
        noSizeAdded: "No size added for now",
        SIZE: "SIZE",
        TAKEAWAY_PRICE: "TAKEAWAY PRICE",
        DELIVERY_PRICE: "DELIVERY PRICE",
        DESCRIPTION: "DESCRIPTION",
        ACTIONS: "ACTIONS",
        addTurkeyBreast: "Add turkey breast",
        addHam: "Add Ham",
        addPowderedSugar: "Add powdered sugar",
        addSauces: "Add sauces",
        addCheese: "Add cheese",
        removeAllOptions: "Remove all options",
        chooseAppropriateRestaurant: "Choose the appropriate restaurant",
        restaurantNotMatchCategory: "The selected restaurant does not match the product category. Please choose the appropriate restaurant.",
        baseIngredients: "Base ingredients",
        updateIngredients: "Update ingredients",
        addBaseIngredients: "Add base ingredients",
        noIngredientSelected: "No ingredient selected",
        searchBaseIngredient: "Search for a base ingredient",
        selectedIngredients: "Selected ingredients",
        noIngredientFound: "No ingredient found for",
        selectPizzaBaseIngredients: "Select pizza base ingredients",
        baseSupplements: "Base supplements",
        updateSupplements: "Update supplements",
        addBaseSupplements: "Add base supplements",
        noSupplementSelected: "No supplement selected",
        searchSupplement: "Search for a supplement",
        selectedSupplements: "Selected supplements",
        noSupplementFound: "No supplement found for",
        selectBaseSupplements: "Select base supplements",
        productNameInLanguage: "Product name in",
        descriptionInLanguage: "Description in",
        notesInLanguage: "Notes in",
        update: "Update",
        categoryResetWarning: "The category has been reset because it does not match the selected restaurant.",
        invalidUrlMessage: "Invalid URL. Please enter a valid URL (e.g. https://example.com/image.jpg)",
        categoryNotBelongRestaurant: "This category does not belong to the selected restaurant. Please choose an appropriate category.",
    },
    category: {
        addCategory: "Add Category",
        editCategory: "Edit Category",
        categoryName: "Category Name",
        categoryDescription: "Category Description",
        categoryImage: "Category Image",
        multilingualTranslations: "Multilingual Translations",
        complete: "Complete",
        incomplete: "Incomplete",
    },
    ingredient: {
        addIngredient: "Add Ingredient",
        editIngredient: "Edit Ingredient",
        ingredientName: "Ingredient Name",
        ingredientDescription: "Ingredient Description",
        ingredientPrice: "Ingredient Price",
        ingredientImage: "Ingredient Image",
        ingredientPosition: "Position",
        ingredientPositionPlaceholder: "e.g. 1, 2, 3...",
        ingredientPositionHelp: "Position of the ingredient in the list (optional)",
        multilingualTranslations: "Multilingual Translations",
        complete: "Complete",
        incomplete: "Incomplete",
        manageTypes: "Manage Types",
        manageTypePositions: "Manage Ingredient Type Positions",
        noTypesAvailable: "No ingredient types available",
        noIngredientTypesAvailable: "No ingredient types available",
        addIngredientType: "Add Ingredient Type",
        editIngredientType: "Edit Ingredient Type",
        code: "Code",
        label: "Label",
        typeCreated: "Ingredient type created successfully",
        typeUpdated: "Ingredient type updated successfully",
        typeDeleted: "Ingredient type deleted successfully",
        errorLoadingTypes: "Error loading ingredient types",
        errorSavingType: "Error saving ingredient type",
        errorDeletingType: "Error deleting ingredient type",
        errorUpdatingPosition: "Error updating position",
        deleteTypeConfirmation: "Delete Confirmation",
        deleteTypeConfirmationText: "Are you sure you want to delete this ingredient type?<br />This action is irreversible. Ingredients associated with this type will have their type set to NULL.",
        codeHelp: "The code must be unique (e.g., FISH, CHEESE, etc.)",
        positionHelp: "Display position (optional, minimum 1)",
        translations: "Translations",
        notDefined: "Not defined",
        manageTranslations: "Manage Translations",
        translationUpdated: "Translation updated successfully",
        errorUpdatingTranslation: "Error updating translation",
        noIngredients: "No ingredients at the moment",
        type: "Type",
        position: "Position",
        deleteConfirmation: "Delete Confirmation",
        deleteConfirmationText: "Are you sure you want to delete this ingredient?<br />This action is irreversible.",
        invalidPosition: "Please enter a valid position (minimum 1)",
        positionUpdated: "Position updated successfully",
        paginationInfo: "Displaying {start} to {end} of {total} results",
        namePlaceholder: "e.g. Pepper",
        managePositions: "Manage Positions",
        selectType: "Select a type",
        typePlaceholder: "Ingredient type in {lang}",
        namePlaceholderLang: "Ingredient name in {lang}",
        icon: "Icon",
        imageUrlPlaceholder: "Paste image URL (e.g. https://...)",
        variationLabel: "Ingredient variation (Specify different sizes)",
        updateVariation: "Update variation",
        addVariation: "Add a variation",
        size: "Size",
        noSizeAdded: "No size added at the moment",
        noSizeAddedModal: "No size added at the moment",
        specifySizes: "Specify the different sizes of the ingredient",
        sizePlaceholder: "Large",
        pricePlaceholder: "12.90",
        remove: "Remove",
        addVariationRequired: "Add at least one variation (size/price) for the ingredient",
    },
    supplement: {
        addSupplement: "Add Supplement",
        editSupplement: "Edit Supplement",
        supplementName: "Supplement Name",
        supplementDescription: "Supplement Description",
        supplementPrice: "Supplement Price",
        supplementImage: "Supplement Image",
        supplementPosition: "Position",
        supplementPositionPlaceholder: "e.g. 1, 2, 3...",
        supplementPositionHelp: "Position of the supplement in the list (optional)",
        multilingualTranslations: "Multilingual Translations",
        complete: "Complete",
        incomplete: "Incomplete",
        manageTypes: "Manage Types",
        manageTypePositions: "Manage Supplement Type Positions",
        noTypesAvailable: "No supplement type available",
        noSupplementTypesAvailable: "No supplement type available",
        addSupplementType: "Add Supplement Type",
        editSupplementType: "Edit Supplement Type",
        code: "Code",
        label: "Label",
        typeCreated: "Supplement type created successfully",
        typeUpdated: "Supplement type updated successfully",
        typeDeleted: "Supplement type deleted successfully",
        errorLoadingTypes: "Error loading supplement types",
        errorSavingType: "Error saving supplement type",
        errorDeletingType: "Error deleting supplement type",
        errorUpdatingPosition: "Error updating position",
        deleteTypeConfirmation: "Delete Confirmation",
        deleteTypeConfirmationText: "Are you sure you want to delete this supplement type?<br />This action is irreversible. Supplements associated with this type will have their type set to NULL.",
        codeHelp: "The code must be unique (e.g., SAUCE, CHEESE, etc.)",
        positionHelp: "Display position (optional, minimum 1)",
        translations: "Translations",
        notDefined: "Not defined",
        manageTranslations: "Manage Translations",
        translationUpdated: "Translation updated successfully",
        errorUpdatingTranslation: "Error updating translation",
        noSupplements: "No supplements at the moment",
        type: "Type",
        position: "Position",
        deleteConfirmation: "Delete Confirmation",
        deleteConfirmationText: "Are you sure you want to delete this supplement?<br />This action is irreversible.",
        invalidPosition: "Please enter a valid position (minimum 1)",
        positionUpdated: "Position updated successfully",
        paginationInfo: "Showing {start} to {end} of {total} results",
        namePlaceholder: "e.g. Hot sauce",
        managePositions: "Manage Positions",
        selectType: "Select a type",
        typePlaceholder: "Supplement type in {lang}",
        namePlaceholderLang: "Supplement name in {lang}",
        icon: "Icon",
        imageUrlPlaceholder: "Supplement image URL",
        variationLabel: "Price Variations",
        updateVariation: "Update Variations",
        addVariation: "Add Variations",
        size: "Size",
        noSizeAdded: "No size added at the moment",
        noSizeAddedModal: "No size added at the moment",
        specifySizes: "Specify the different sizes of the supplement",
        sizePlaceholder: "Large",
        pricePlaceholder: "2.50",
        remove: "Remove",
        addVariationRequired: "Add at least one variation (size/price) for the supplement",
    },
    feature: {
        addFeature: "Add Feature",
        editFeature: "Edit Feature",
        featureName: "Feature Name",
        featureDescription: "Feature Description",
        featurePrice: "Feature Price",
        featureImage: "Feature Image",
        featurePosition: "Position",
        featurePositionPlaceholder: "e.g. 1, 2, 3...",
        featurePositionHelp: "Position of the feature in the list (optional)",
        multilingualTranslations: "Multilingual Translations",
        complete: "Complete",
        incomplete: "Incomplete",
        translations: "Translations",
        notDefined: "Not defined",
        manageTranslations: "Manage Translations",
        translationUpdated: "Translation updated successfully",
        errorUpdatingTranslation: "Error updating translation",
        noFeatures: "No features at the moment",
        position: "Position",
        deleteConfirmation: "Delete Confirmation",
        deleteConfirmationText: "Are you sure you want to delete this feature?<br />This action is irreversible.",
        invalidPosition: "Please enter a valid position (minimum 1)",
        positionUpdated: "Position updated successfully",
        paginationInfo: "Showing {start} to {end} of {total} results",
        namePlaceholder: "e.g. New Feature",
        managePositions: "Manage Positions",
        namePlaceholderLang: "Feature name in {lang}",
        icon: "Icon",
        imageUrlPlaceholder: "Feature image URL",
        variationLabel: "Price Variations",
        updateVariation: "Update Variations",
        addVariation: "Add Variations",
        size: "Size",
        noSizeAdded: "No size added at the moment",
        noSizeAddedModal: "No size added at the moment",
        specifySizes: "Specify the different sizes of the feature",
        sizePlaceholder: "Large",
        pricePlaceholder: "2.50",
        remove: "Remove",
        addVariationRequired: "Add at least one variation (size/price) for the feature",
        features: "Features",
    },
    auth: {
        login: "Login",
        loginButton: "Log In",
        register: "Register",
        registerButton: "Sign Up",
        createAccount: "Create Your Account",
        forgotPassword: "Forgot Password?",
        forgotPasswordText: "Enter your e-mail address below and we will send you the recovered password",
        resetPassword: "Reset Password",
        email: "E-mail",
        emailAddress: "E-mail Address",
        password: "Password",
        confirmPassword: "Confirm Password",
        firstName: "First Name",
        lastName: "Last Name",
        name: "Name",
        rememberMe: "Remember",
        backToSignIn: "Back To Sign In",
        alreadyHaveAccount: "Already Have An Account?",
        dontHaveAccount: "Don't have an account?",
        logInNow: "Log In Now",
        registerNow: "Register Now",
        acceptTerms: "I accept All",
        termsAndConditions: "Terms & Conditions",
        submit: "Submit",
        invalidCredentials: "Invalid username or password",
        missingToken: "Missing authentication token",
    },
    validation: {
        required: "This field is required",
        email: "Please enter a valid e-mail",
        minLength: "This field must contain at least {min} characters",
        maxLength: "This field cannot exceed {max} characters",
        passwordMismatch: "Passwords do not match",
    },
    messages: {
        success: {
            saved: "Successfully saved",
            deleted: "Successfully deleted",
            updated: "Successfully updated",
            paymentMethodUpdated: "Payment method updated successfully",
            paymentMethodActivated: "Payment method activated successfully",
            paymentMethodDeactivated: "Payment method deactivated successfully",
            paymentMethodAdded: "Payment method added successfully",
            userDeleted: "User deleted successfully",
            userStatusUpdated: "User status updated successfully",
            postalCodeAdded: "Postal code added successfully",
            postalCodeRemoved: "Postal code {code} removed",
            variationsUpdated: "Variations updated successfully",
            imageSelected: "Image selected successfully",
            openingHoursDeleted: "Opening hours deleted successfully",
            userAddedToCampaign: "User added to campaign",
            couponRemoved: "Coupon removed",
            newOrderReceived: "New order received!",
            newOrderInRestaurant: "New order in a restaurant",
            ingredientAdded: "Ingredient added successfully",
            ingredientRemoved: "Ingredient removed successfully",
            baseIngredientsValidated: "Base ingredients validated",
            supplementAdded: "Supplement added successfully",
            supplementRemoved: "Supplement removed successfully",
            baseSupplementsValidated: "Base supplements validated",
            printTicketSuccess: "🎉 Ticket printed successfully",
            timeSlotDeleted: "Time slot deleted successfully",
            timeSlotActivated: "Time slot activated successfully",
            timeSlotDeactivated: "Time slot deactivated successfully",
        },
        error: {
            generic: "An error occurred",
            loadFailed: "Failed to load",
            network: "Connection error",
            unauthorized: "Unauthorized",
            notFound: "Resource not found",
            invalidPaymentMethod: "Invalid payment method",
            paymentMethodUpdateFailed: "Error updating payment method",
            loadPaymentMethodsFailed: "Error loading payment methods",
            updateFailed: "Error updating",
            statusUpdateFailed: "Error updating status",
            paymentStatusUpdateFailed: "Error updating payment status",
            deleteUserFailed: "Error deleting user",
            updateUserStatusFailed: "Error updating user status",
            loadUsersFailed: "Error loading users",
            restaurantIdNotFound: "Restaurant ID not found",
            loadDeliveryZoneFailed: "Error loading delivery zone",
            loadCategoriesFailed: "Error loading categories",
            loadRestaurantsFailed: "Error loading restaurants",
            loadOrdersFailed: "Error loading orders",
            loadCampaignsFailed: "Error loading campaigns",
            loadProductsFailed: "Error loading products",
            loadIngredientsFailed: "Error loading ingredients",
            loadSupplementsFailed: "Error loading supplements",
            loadIngredientBasesFailed: "Error loading base ingredients",
            loadOpeningHoursFailed: "Error loading opening hours",
            loadDeliveryZonesFailed: "Error loading delivery zones",
            loadTimeSlotsFailed: "Error loading time slots",
            loadCouponsFailed: "Error loading coupons",
            loadFranchisesFailed: "Error loading franchises",
            loadOperationsFailed: "Error loading operations",
            loadDataFailed: "Error loading data",
            loadPostalCodesFailed: "Error loading postal codes",
            loadOrderTypesFailed: "Error loading order types",
            loadCustomerInfoFailed: "Error loading customer information",
            loadTimeSlotFailed: "Error loading time slot",
            saveFeatureFailed: "Error saving feature",
            loadFeatureFailed: "Error loading feature",
            deleteFeatureFailed: "Error deleting feature",
            updateFeaturePositionFailed: "Error updating feature position",
            fileTypeNotAllowed: "File type not allowed",
            fileTooLarge: "File too large",
            invalidQuantity: "Invalid quantity",
            restaurantInfoMissing: "Restaurant information missing",
            fillAllFields: "Please fill all fields",
            couponAlreadyApplied: "A coupon is already applied",
            enterPromoCode: "Please enter a promo code",
            invalidPromoCode: "Invalid promo code",
            imageUploadFailed: "Error uploading image",
            selectValidImageFile: "Please select a valid image file",
            fileSizeExceeded: "File size must not exceed 5MB",
            deletionFailed: "Error during deletion",
            invalidPrice: "Price must be a valid number",
            ingredientBaseNameRequired: "Base ingredient name is required",
            deleteTimeSlotFailed: "Error deleting time slot",
            deleteOrderFailed: "Error deleting order",
            deleteVariationFailed: "Error deleting variation",
            deleteProductFailed: "Error deleting product",
            deletePostalCodeFailed: "Error deleting postal code",
            deleteZoneFailed: "Error deleting zone",
            updateStatusFailed: "Error updating status",
            updateZoneFailed: "Error updating zone",
            updateStelaStatusFailed: "Error updating stela status",
            updateFeaturedStatusFailed: "Error updating featured status",
            selectRestaurant: "Please select a restaurant",
            saveTimeSlotFailed: "Error saving time slot",
            saveOpeningHoursFailed: "Error saving opening hours",
            generatePdfFailed: "Error generating PDF",
            printTicketFailed: "Error printing ticket",
            loadExistingIngredientsFailed: "Error loading existing ingredients",
            fillRequiredFields: "Please fill all required fields",
            restaurantNotSelected: "Restaurant not selected",
            provideImageOrUrl: "Please provide an image (file or URL)",
            urlMustStartWithHttps: "URL must start with https://",
            ingredientAlreadyAdded: "This ingredient is already added",
            supplementAlreadyAdded: "This supplement is already added",
            loadExistingSupplementsFailed: "Error loading existing supplements",
            invalidProductId: "Invalid product ID",
            missingCategoryId: "Missing category ID",
            editFeatureToImplement: "Edit feature to be implemented",
            loadUserAddressesFailed: "Error loading user addresses",
            loadRestaurantInfoFailed: "Error loading restaurant information",
            loadRestaurantDetailsFailed: "Error loading restaurant details",
            reloadDataFailed: "Error reloading data",
            loadProductFailed: "Error loading product",
        },
        warning: {
            userAlreadyInList: "This user is already in the list",
            selectUser: "Please select a user",
            couponAlreadyApplied: "A coupon is already applied",
        },
    },
    reports: {
        ordersByStatus: {
            title: "Orders by status",
            subtitle: "Filter by period and status, then view count and amount.",
            columns: {
                status: "Status",
                count: "Count",
                amount: "Amount",
            },
            empty: "No data for this period.",
        },
        averageBasket: {
            title: "Average basket",
            subtitle: "Filter by period, order type, payment method and status.",
            valueLabel: "Average basket",
            columns: {
                count: "Count",
                totalAmount: "Amount",
                averageBasket: "Average basket",
            },
            empty: "No data for this period.",
        },
    },
    lists: {
        add: "Add",
        search: "Search",
        searchProduct: "Search for a product",
        searchOrder: "Search for an order",
        filterByCategory: "Filter by category",
        selectRestaurant: "Select a restaurant",
        restaurant: "Restaurant",
        id: "ID",
        name: "NAME",
        category: "CATEGORY",
        status: "STATUS",
        notificationStatus: {
            draft: "Draft",
            sent: "Sent",
        },
        createdAt: "CREATED ON",
        featured: "FEATURED",
        size: "SIZE",
        ref: "REF",
        type: "TYPE",
        client: "CLIENT",
        amount: "AMOUNT",
        orderStatus: "ORDER STATUS",
        paymentStatus: "PAYMENT STATUS",
        phoneNumber: "PHONE NUMBER",
        actions: "ACTIONS",
        cancel: "Cancel",
        delete: "Delete",
        confirmDelete: "Are you sure you want to delete this product?",
        confirmDeleteText: "This action is irreversible.",
        takeaway: "Takeaway",
        dineIn: "Dine in",
        delivery: "Delivery",
        pending: "Pending",
        confirmed: "Confirmed",
        preparing: "Preparing",
        ready: "Ready",
        delivered: "Delivered",
        cancelled: "Cancelled",
        processing: "Processing",
        readyForDelivery: "Ready for delivery",
        delivering: "Out for delivery",
        awaitingPayment: "Awaiting payment",
        paid: "Paid",
        refunded: "Refunded",
        paymentCancelled: "Cancelled",
        icon: "ICON",
        availability: "AVAILABILITY",
        extraPrice: "EXTRA PRICE",
        searchCustomer: "Search for a customer",
        searchUser: "Search for a user",
        clearSearch: "Clear search",
        fullName: "FULL NAME",
        email: "E-MAIL",
        phone: "PHONE",
        accountType: "ACCOUNT TYPE",
        verification: "VERIFICATION",
        addUser: "Add User",
        userDetails: "User Details",
        editHeadRestaurant: "Edit the restaurant manager",
        addRestaurant: "Add Restaurant",
        uploadMenu: "Upload Menu",
        selectPdfFile: "Select a PDF file",
        maxFileSize: "Maximum file size",
        acceptedFormat: "Accepted format",
        selectedFile: "Selected file",
        uploading: "Uploading...",
        upload: "Upload",
        addTimeSlot: "Add Time Slot",
        addDeliveryZone: "Add Delivery Zone",
        searchRestaurant: "Search for a restaurant",
        searchTimeSlot: "Search for a time slot",
        searchZone: "Search for a zone",
        restaurantName: "RESTAURANT NAME",
        managerName: "MANAGER NAME",
        zoneAndAddress: "ZONE & ADDRESS",
        zoneName: "ZONE NAME",
        minimumAmount: "MINIMUM AMOUNT",
        deliveryFee: "DELIVERY FEE",
        freeDeliveryThreshold: "FREE DELIVERY THRESHOLD",
        postalCodes: "POSTAL CODES",
        confirmDeleteTimeSlot: "Are you sure you want to delete this time slot?",
        confirmDeleteRestaurant: "Are you sure you want to delete this restaurant?",
        confirmDeleteDeliveryZone: "Are you sure you want to delete this delivery zone?",
        addCampaign: "Add Campaign",
        searchCampaign: "Search for a campaign",
        confirmDeleteCampaign: "Are you sure you want to delete this campaign?",
        campaignId: "ID",
        campaignTitle: "TITLE",
        campaignMessage: "MESSAGE",
        campaignStatus: "STATUS",
        campaignRecipients: "RECIPIENTS",
        campaignCreatedAt: "CREATED ON",
        recipient: "recipient",
        recipients: "recipient(s)",
        selectedRecipients: "selected recipient(s)",
        view: "View",
        send: "Send",
        verified: "Verified",
        unverified: "Not verified",
        noCustomers: "No customers at the moment",
        noUsers: "No users at the moment",
        confirmDeleteUser: "Delete Confirmation",
        confirmDeleteUserText: "Are you sure you want to delete this user?",
        confirmDeleteUserAction: "This action is irreversible.",
        noCampaigns: "No campaigns at the moment",
        displayResults: "Displaying {start} to {end} of {total} results",
        pickupDelay: "Pickup delay",
        deliveryDelay: "Delivery delay",
        noTimeSlots: "No time slots at the moment",
        confirmDeleteTitle: "Delete Confirmation",
        campaignStatuses: {
            sent: "Sent",
            pending: "Pending",
            draft: "Draft",
            scheduled: "Scheduled",
        },
        campaignTypes: {
            individual: "Individual",
            group: "Group",
        },
        allRestaurants: "All restaurants",
        addToCampaign: "Add to campaign",
        removeRecipient: "Remove this recipient",
        usersAddedAutomatically: "{count} users added automatically",
        addCoupon: "Add Coupon",
        searchCoupon: "Search for a coupon",
        confirmDeleteCoupon: "Are you sure you want to delete this coupon?",
        manageOpeningHours: "Manage your restaurant's opening hours",
        addOpeningHours: "Add hours",
        noOpeningHours: "No hours configured",
        startConfigureOpeningHours: "Start by configuring your restaurant's opening hours.",
        configureOpeningHours: "Configure hours",
        managePaymentMethods: "Manage your restaurant's payment methods",
        addPaymentMethod: "Add payment method",
        paymentMethod: "Payment Method",
        noPaymentMethods: "No payment methods configured",
        startConfigurePaymentMethods: "Start by configuring your restaurant's payment methods.",
        configurePaymentMethods: "Configure payment methods",
        enabled: "Enabled",
        disabled: "Disabled",
        selectPaymentMethod: "Select payment method",
        enablePaymentMethod: "Enable payment method",
        selectRestaurantFirst: "Please select a restaurant first",
        day: "Day",
        hours: "Hours",
        break: "Break",
        closed: "Closed",
        searchTransaction: "Search for a transaction",
        transactionId: "TRANSACTION ID",
        orderId: "ORDER ID",
        confirmDeleteTransaction: "Are you sure you want to delete this transaction?",
        addIngredientBase: "Add Base Ingredient",
        searchIngredientBase: "Search for a base ingredient",
        addNotification: "Add Notification",
        searchNotification: "Search for a notification",
        confirmDeleteNotification: "Are you sure you want to delete this notification?",
        searchProgram: "Search for a program",
        programName: "PROGRAM NAME",
        rewardEarned: "REWARD EARNED",
        confirmDeleteProgram: "Are you sure you want to delete this program?",
        noPrograms: "No programs available at the moment",
        referral: "REFERRAL",
        loyalty: "LOYALTY",
        addFranchise: "Add Franchise",
        searchFranchise: "Search for a franchise",
        confirmDeleteFranchise: "Are you sure you want to delete this franchise?",
        title: "TITLE",
        message: "MESSAGE",
        edit: "Edit",
        confirmDeleteFranchiseText: "Are you sure you want to delete this franchise?",
        show: "Show",
        platform: "PLATFORM",
        translations: "Translations"
    },
    forms: {
        restaurantImage: "Restaurant Image Banner",
        website: "Website",
        enablePosWalkthrough: "Enable POS Walkthrough",
        posWalkthroughDescription: "If enabled, restaurant staff will see a guided tour when using the POS for the first time.",
        sendingType: "Sending Type",
        notificationType: "Notification Type",
        targetChoice: "Target Choice",
        example: "e.g.",
        passwordPlaceholder: "**************",
        phoneNumber: "Phone number",
        country: "Country",
        switzerland: "Switzerland",
        france: "France",
        germany: "Germany",
        italy: "Italy",
        unitedKingdom: "United Kingdom",
        unitedStates: "United States",
        belgium: "Belgium",
        austria: "Austria",
        selectRestaurantPlaceholder: "Select a restaurant",
        selectTypePlaceholder: "Select a type",
        selectCategoryPlaceholder: "Select a category",
        searchCategoryPlaceholder: "Search for a category",
        chooseFile: "Choose a file",
        imageUrlPlaceholder: "https://example.com/image.jpg",
        searchIngredientPlaceholder: "Type to search for an ingredient...",
        searchSupplementPlaceholder: "Type to search for a supplement...",
        searchFeaturePlaceholder: "Type to search for a feature...",
        sizePlaceholder: "Large",
        sizeDescriptionPlaceholder: "Give a description for this size",
        categoryDescriptionPlaceholder: "Give a description to the category",
        online: "Online",
        atDelivery: "On delivery",
        powderedSugar: "Powdered sugar",
        addParmesan: "Add parmesan",
        addSauces: "Add sauces",
        customize: "Customize",
        ham: "Ham",
        turkeyBreast: "Turkey Breast",
        italianSauce: "Italian Sauce",
        postalCode: "Postal code",
        selectPostalCode: "Select postal code",
        city: "City",
        selectCity: "Select city",
        street: "Street",
        role: "Role",
        selectRole: "Select a role",
        technicalSupport: "TECHNICAL SUPPORT",
        oldPassword: "Old password",
        newPassword: "New password",
        restaurantName: "Restaurant Name",
        managerFirstName: "Manager first name",
        managerLastName: "Manager last name",
        vatNumber: "VAT number",
        vatRate: "VAT Rate (%)",
        address: "Address",
        streetNumber: "Street number",
        zoneName: "Zone name",
        minimumAmount: "Minimum amount (CHF)",
        deliveryFee: "Delivery fee (CHF)",
        deliveryFeePlaceholder: "e.g. 5.00 (leave empty for free)",
        freeDeliveryThreshold: "Free delivery threshold (CHF)",
        freeDeliveryThresholdPlaceholder: "e.g. 30.00 (leave empty for no threshold)",
        description: "Description",
        zoneDescription: "Zone description",
        postalCodes: "Postal codes",
        postalCodePlaceholder: "Postal code",
        locality: "Locality",
        add: "Add",
        postalCodesAdded: "postal code(s) added",
        noPostalCodes: "No postal codes added. You can add them after creating the zone.",
        removePostalCode: "Remove this postal code",
        postalCodeLocalityAlreadyAdded: "This postal code and locality combination has already been added",
        fillAllFields: "Please fill in all fields",
        createZone: "Create zone",
        updateZone: "Update",
        pickupDelay: "Pickup delay (minutes)",
        pickupDelayPlaceholder: "Ex: 20",
        pickupDelayHelp: "Waiting time for pickup orders",
        deliveryDelay: "Delivery delay (minutes)",
        deliveryDelayPlaceholder: "Ex: 45",
        deliveryDelayHelp: "Waiting time for delivery orders",
        slotInterval: "Slot interval (minutes)",
        slotIntervalPlaceholder: "Ex: 15",
        slotIntervalHelp: "Interval between each available slot",
        maxCapacity: "Maximum capacity",
        maxCapacityPlaceholder: "Ex: 1",
        maxCapacityHelp: "Maximum number of orders per slot",
        startTime: "Start time",
        startTimeHelp: "Slot start time",
        endTime: "End time",
        endTimeHelp: "Slot end time",
        activateConfig: "Activate this configuration",
        timeSlotExample: "Example: If a customer orders at 12:00 for delivery, the next available pre-order will be at 12:45 (12:00 + 45 minutes).",
        editTimeSlot: "Edit time slot",
        addTimeSlot: "Add time slot",
        configureDelays: "Configure delays for pickup and delivery orders",
        updateTimeSlot: "Update",
        title: "Title",
        titlePlaceholder: "e.g. New",
        campaignDescription: "Campaign description",
        recipients: "Recipients",
        selectRestaurant: "Select a restaurant",
        type: "Type",
        typeLabel: "Type",
        selectType: "Select type",
        selectClient: "Select a client",
        addToCampaign: "Add to campaign",
        clientsAdded: "client(s) added",
        selectDateTime: "Select date and time",
        couponCode: "Coupon code",
        couponCodePlaceholder: "e.g. 5",
        value: "Value",
        limit: "Limit",
        limitPlaceholder: "e.g. 10",
        noUserFound: "No user found",
        franchiseName: "Franchise name",
        franchiseDescription: "Franchise description",
        franchiseDescriptionPlaceholder: "Describe the franchise and its activities (specialty, creation date, etc...)",
        image: "Image",
        uploadImage: "Upload an image",
        imagePreview: "Image preview",
        removeImage: "Remove image",
        changeImage: "Change image",
        selectImage: "Select an image",
        imageSizeWarning: "Image size must not exceed 1 MB.",
        programName: "Program name",
        programDescription: "Program description",
        programDescriptionPlaceholder: "Give a description to the program",
        gain: "Gain",
        gainPlaceholder: "e.g. Pizza",
        openingHoursTitle: "Opening hours",
        manageOpeningHours: "Manage your restaurant's opening hours",
        addAddress: "Add an address",
        noAddressSaved: "No address saved.",
        page: "Page",
        noOrders: "No orders.",
        show: "Show",
        transactionReference: "Transaction reference",
        pdf: "PDF",
        civility: "Civility",
        lastName: "Last name",
        firstName: "First name",
        email: "E-mail",
        phone: "Phone",
        dateOfBirth: "Date of Birth",
        companyName: "Company name",
        companyAddress: "Company address",
        companyVat: "Company VAT",
        companyPhone: "Company phone",
        companyEmail: "Company e-mail",
        customerInfo: "Customer information",
        useCustomerGenericInfo: "Use customer information",
        quantityUtensils: "Utensils quantity",
        orderDate: "Date",
        orderTime: "Time",
        whenOrderDesired: "When would you like your order?",
        dateAndTimeDesired: "Desired date and time",
        immediately: "Immediately",
        whatToPayAttention: "What should we pay attention to?",
        orderInstructions: "Order instructions",
        productName: "Product name",
        quantity: "Quantity",
        price: "Price",
        totalAmount: "Total amount",
        ingredient: "Ingredient",
        addIngredient: "Add ingredient",
        noProductInCart: "No products added to cart at the moment",
        availableIn: "Available in",
        size: "size",
        choose: "Choose",
        cart: "Cart",
        generalInfo: "General Information",
        chooseSize: "Choose size",
        selectAdditionalIngredients: "Select additional ingredients",
        selectIngredient: "Select an ingredient",
        averageAmount: "Average amount",
        product: "Product",
        startDate: "Start",
        endDate: "End",
        start: "Start",
        end: "End",
        category: "Category",
        orderType: "Order type",
        selectOrderType: "Select an order type",
        salesThisWeek: "SALES THIS WEEK",
        totalOrders: "Total orders",
        totalSales: "Total sales",
        totalCustomers: "Total customers",
        totalProducts: "Total products",
        totalCategories: "Total categories",
        totalIngredients: "Total ingredients",
        totalTimeSlots: "Total time slots",
        totalDeliveryZones: "Total delivery zones",
        totalUsers: "Total users",
        totalRestaurants: "Total restaurants",
        totalFranchises: "Total franchises",
        totalCoupons: "Total coupons",
        totalCampaigns: "Total campaigns",
        totalNotifications: "Total notifications",
        totalPrograms: "Total programs",
        totalIngredientBases: "Total base ingredients",
        totalOpeningHours: "Total opening hours",
        totalTransactions: "Total transactions",
        totalCustomersThisMonth: "Total customers this month",
        totalOrdersThisMonth: "Total orders this month",
        totalSalesThisMonth: "Total sales this month",
        totalProductsThisMonth: "Total products this month",
        totalCategoriesThisMonth: "Total categories this month",
        totalIngredientsThisMonth: "Total ingredients this month",
        totalTimeSlotsThisMonth: "Total time slots this month",
        totalDeliveryZonesThisMonth: "Total delivery zones this month",
        totalUsersThisMonth: "Total users this month",
        totalRestaurantsThisMonth: "Total restaurants this month",
        totalFranchisesThisMonth: "Total franchises this month",
        totalCouponsThisMonth: "Total coupons this month",
        totalCampaignsThisMonth: "Total campaigns this month",
        totalNotificationsThisMonth: "Total notifications this month",
        totalProgramsThisMonth: "Total programs this month",
        totalIngredientBasesThisMonth: "Total base ingredients this month",
        totalOpeningHoursThisMonth: "Total opening hours this month",
        totalTransactionsThisMonth: "Total transactions this month",
        totalCustomersLastMonth: "Total customers last month",
        totalOrdersLastMonth: "Total orders last month",
        totalSalesLastMonth: "Total sales last month",
        totalProductsLastMonth: "Total products last month",
        totalCategoriesLastMonth: "Total categories last month",
        totalIngredientsLastMonth: "Total ingredients last month",
        totalTimeSlotsLastMonth: "Total time slots last month",
        totalDeliveryZonesLastMonth: "Total delivery zones last month",
        totalUsersLastMonth: "Total users last month",
        totalRestaurantsLastMonth: "Total restaurants last month",
        totalFranchisesLastMonth: "Total franchises last month",
        totalCouponsLastMonth: "Total coupons last month",
        totalCampaignsLastMonth: "Total campaigns last month",
        totalNotificationsLastMonth: "Total notifications last month",
        totalProgramsLastMonth: "Total programs last month",
        totalIngredientBasesLastMonth: "Total base ingredients last month",
        totalOpeningHoursLastMonth: "Total opening hours last month",
        totalTransactionsLastMonth: "Total transactions last month",
        totalCustomersLastYear: "Total customers last year",
        totalOrdersLastYear: "Total orders last year",
        totalSalesLastYear: "Total sales last year",
        totalProductsLastYear: "Total products last year",
        totalCategoriesLastYear: "Total categories last year",
        totalIngredientsLastYear: "Total ingredients last year",
        totalTimeSlotsLastYear: "Total time slots last year",
        totalDeliveryZonesLastYear: "Total delivery zones last year",
        totalUsersLastYear: "Total users last year",
        totalRestaurantsLastYear: "Total restaurants last year",
        totalFranchisesLastYear: "Total franchises last year",
        totalCouponsLastYear: "Total coupons last year",
        totalCampaignsLastYear: "Total campaigns last year",
        totalNotificationsLastYear: "Total notifications last year",
        totalProgramsLastYear: "Total programs last year",
        totalIngredientBasesLastYear: "Total base ingredients last year",
        totalOpeningHoursLastYear: "Total opening hours last year",
        totalTransactionsLastYear: "Total transactions last year",
        totalCustomersAllTime: "Total customers all time",
        totalOrdersAllTime: "Total orders all time",
        totalSalesAllTime: "Total sales all time",
        totalProductsAllTime: "Total products all time",
        totalCategoriesAllTime: "Total categories all time",
        totalIngredientsAllTime: "Total ingredients all time",
        totalTimeSlotsAllTime: "Total time slots all time",
        totalDeliveryZonesAllTime: "Total delivery zones all time",
        totalUsersAllTime: "Total users all time",
        totalRestaurantsAllTime: "Total restaurants all time",
        totalFranchisesAllTime: "Total franchises all time",
        totalCouponsAllTime: "Total coupons all time",
        totalCampaignsAllTime: "Total campaigns all time",
        totalNotificationsAllTime: "Total notifications all time",
        totalProgramsAllTime: "Total programs all time",
        totalIngredientBasesAllTime: "Total base ingredients all time",
        totalOpeningHoursAllTime: "Total opening hours all time",
        totalTransactionsAllTime: "Total transactions all time",
        totalCustomersToday: "Total customers today",
        totalOrdersToday: "Total orders today",
        totalSalesToday: "Total sales today",
        totalProductsToday: "Total products today",
        totalCategoriesToday: "Total categories today",
        totalIngredientsToday: "Total ingredients today",
        totalTimeSlotsToday: "Total time slots today",
        totalDeliveryZonesToday: "Total delivery zones today",
        totalUsersToday: "Total users today",
        totalRestaurantsToday: "Total restaurants today",
        totalFranchisesToday: "Total franchises today",
        totalCouponsToday: "Total coupons today",
        totalCampaignsToday: "Total campaigns today",
        totalNotificationsToday: "Total notifications today",
        totalProgramsToday: "Total programs today",
        totalIngredientBasesToday: "Total base ingredients today",
        totalOpeningHoursToday: "Total opening hours today",
        totalTransactionsToday: "Total transactions today",
        totalCustomersYesterday: "Total customers yesterday",
        totalOrdersYesterday: "Total orders yesterday",
        totalSalesYesterday: "Total sales yesterday",
        totalProductsYesterday: "Total products yesterday",
        totalCategoriesYesterday: "Total categories yesterday",
        totalIngredientsYesterday: "Total ingredients yesterday",
        totalTimeSlotsYesterday: "Total time slots yesterday",
        totalDeliveryZonesYesterday: "Total delivery zones yesterday",
        totalUsersYesterday: "Total users yesterday",
        totalRestaurantsYesterday: "Total restaurants yesterday",
        totalFranchisesYesterday: "Total franchises yesterday",
        totalCouponsYesterday: "Total coupons yesterday",
        totalCampaignsYesterday: "Total campaigns yesterday",
        totalNotificationsYesterday: "Total notifications yesterday",
        totalProgramsYesterday: "Total programs yesterday",
        totalIngredientBasesYesterday: "Total base ingredients yesterday",
        totalOpeningHoursYesterday: "Total opening hours yesterday",
        totalTransactionsYesterday: "Total transactions yesterday",
        totalCustomersLast7Days: "Total customers last 7 days",
        totalOrdersLast7Days: "Total orders last 7 days",
        totalSalesLast7Days: "Total sales last 7 days",
        totalProductsLast7Days: "Total products last 7 days",
        totalCategoriesLast7Days: "Total categories last 7 days",
        totalIngredientsLast7Days: "Total ingredients last 7 days",
        totalTimeSlotsLast7Days: "Total time slots last 7 days",
        totalDeliveryZonesLast7Days: "Total delivery zones last 7 days",
        totalUsersLast7Days: "Total users last 7 days",
        totalRestaurantsLast7Days: "Total restaurants last 7 days",
        totalFranchisesLast7Days: "Total franchises last 7 days",
        totalCouponsLast7Days: "Total coupons last 7 days",
        totalCampaignsLast7Days: "Total campaigns last 7 days",
        totalNotificationsLast7Days: "Total notifications last 7 days",
        totalProgramsLast7Days: "Total programs last 7 days",
        totalIngredientBasesLast7Days: "Total base ingredients last 7 days",
        totalOpeningHoursLast7Days: "Total opening hours last 7 days",
        totalTransactionsLast7Days: "Total transactions last 7 days",
        totalCustomersLast30Days: "Total customers last 30 days",
        totalOrdersLast30Days: "Total orders last 30 days",
        totalSalesLast30Days: "Total sales last 30 days",
        totalProductsLast30Days: "Total products last 30 days",
        totalCategoriesLast30Days: "Total categories last 30 days",
        totalIngredientsLast30Days: "Total ingredients last 30 days",
        totalTimeSlotsLast30Days: "Total time slots last 30 days",
        totalDeliveryZonesLast30Days: "Total delivery zones last 30 days",
        totalUsersLast30Days: "Total users last 30 days",
        totalRestaurantsLast30Days: "Total restaurants last 30 days",
        totalFranchisesLast30Days: "Total franchises last 30 days",
        totalCouponsLast30Days: "Total coupons last 30 days",
        totalCampaignsLast30Days: "Total campaigns last 30 days",
        totalNotificationsLast30Days: "Total notifications last 30 days",
        totalProgramsLast30Days: "Total programs last 30 days",
        totalIngredientBasesLast30Days: "Total base ingredients last 30 days",
        totalOpeningHoursLast30Days: "Total opening hours last 30 days",
        totalTransactionsLast30Days: "Total transactions last 30 days",
        totalCustomersLast90Days: "Total customers last 90 days",
        totalOrdersLast90Days: "Total orders last 90 days",
        totalSalesLast90Days: "Total sales last 90 days",
        totalProductsLast90Days: "Total products last 90 days",
        totalCategoriesLast90Days: "Total categories last 90 days",
        totalIngredientsLast90Days: "Total ingredients last 90 days",
        totalTimeSlotsLast90Days: "Total time slots last 90 days",
        totalDeliveryZonesLast90Days: "Total delivery zones last 90 days",
        totalUsersLast90Days: "Total users last 90 days",
        totalRestaurantsLast90Days: "Total restaurants last 90 days",
        totalFranchisesLast90Days: "Total franchises last 90 days",
        totalCouponsLast90Days: "Total coupons last 90 days",
        totalCampaignsLast90Days: "Total campaigns last 90 days",
        totalNotificationsLast90Days: "Total notifications last 90 days",
        totalProgramsLast90Days: "Total programs last 90 days",
        totalIngredientBasesLast90Days: "Total base ingredients last 90 days",
        totalOpeningHoursLast90Days: "Total opening hours last 90 days",
        totalTransactionsLast90Days: "Total transactions last 90 days",
        totalCustomersLast365Days: "Total customers last 365 days",
        totalOrdersLast365Days: "Total orders last 365 days",
        totalSalesLast365Days: "Total sales last 365 days",
        totalProductsLast365Days: "Total products last 365 days",
        totalCategoriesLast365Days: "Total categories last 365 days",
        totalIngredientsLast365Days: "Total ingredients last 365 days",
        totalTimeSlotsLast365Days: "Total time slots last 365 days",
        totalDeliveryZonesLast365Days: "Total delivery zones last 365 days",
        totalUsersLast365Days: "Total users last 365 days",
        totalRestaurantsLast365Days: "Total restaurants last 365 days",
        totalFranchisesLast365Days: "Total franchises last 365 days",
        totalCouponsLast365Days: "Total coupons last 365 days",
        totalCampaignsLast365Days: "Total campaigns last 365 days",
        totalNotificationsLast365Days: "Total notifications last 365 days",
        totalProgramsLast365Days: "Total programs last 365 days",
        totalIngredientBasesLast365Days: "Total base ingredients last 365 days",
        totalOpeningHoursLast365Days: "Total opening hours last 365 days",
        totalTransactionsLast365Days: "Total transactions last 365 days",
        totalCustomersLastWeek: "Total customers last week",
        totalOrdersLastWeek: "Total orders last week",
        totalSalesLastWeek: "Total sales last week",
        totalProductsLastWeek: "Total products last week",
        totalCategoriesLastWeek: "Total categories last week",
        totalIngredientsLastWeek: "Total ingredients last week",
        totalTimeSlotsLastWeek: "Total time slots last week",
        totalDeliveryZonesLastWeek: "Total delivery zones last week",
        totalUsersLastWeek: "Total users last week",
        totalRestaurantsLastWeek: "Total restaurants last week",
        totalFranchisesLastWeek: "Total franchises last week",
        totalCouponsLastWeek: "Total coupons last week",
        totalCampaignsLastWeek: "Total campaigns last week",
        totalNotificationsLastWeek: "Total notifications last week",
        totalProgramsLastWeek: "Total programs last week",
        totalIngredientBasesLastWeek: "Total base ingredients last week",
        totalOpeningHoursLastWeek: "Total opening hours last week",
        totalTransactionsLastWeek: "Total transactions last week",
        filterByRestaurant: "Filter by restaurant",
        amountOrdersByCategory: "AMOUNT OF ORDERS BY (CATEGORY)",
        amountOrdersByProduct: "AMOUNT OF ORDERS BY (PRODUCT)",
        allTypes: "All types",
        allMethods: "All methods",
        orders: "order(s)",
        Orders: "Order(s)",
        averageQuantityPerOrder: "AVERAGE QUANTITY OF A PRODUCT PER ORDER",
        errorLoadingCategories: "Error loading categories",
        errorLoadingProducts: "Error loading products",
        errorLoadingData: "Error loading data",
        errorLoadingRestaurant: "Error loading restaurants",
        errorLoadingAverage: "Error retrieving average",
        errorLoadingAverageRate: "Error loading average rate",
        pleaseSelectRestaurant: "Please select a specific restaurant to view data.",
        pleaseSelectRestaurantRefresh: "Please select a restaurant to refresh data.",
        noProductDataForPeriod: "No product data for this period",
        noCategoryDataForPeriod: "No category data for this period",
        allowOrderModification: "Allow order modification",
        allowOrderDeletion: "Allow order deletion",
        allowOrderAcceptation: "Allow order acceptance",
        showGoogleMapsQr: "Show Google Maps QR on tickets",
        showGoogleMapsQrHelp: "Indicates whether the Google Maps QR code should be displayed on tickets",
    },
    ingredientBase: {
        addIngredientBase: "Add Base Ingredient",
        editIngredientBase: "Edit Base Ingredient",
        ingredientBaseName: "Base Ingredient Name",
        ingredientBaseNameHelp: "Enter the name of the base ingredient for pizzas",
        ingredientBasePosition: "Position",
        ingredientBasePositionPlaceholder: "e.g. 1, 2, 3...",
        ingredientBasePositionHelp: "Position of the base ingredient in the list (optional)",
    },
    pos: {
        searchMenuPlaceholder: "Search in the menu...",
        noCategoriesFound: "No categories found",
        errorLoadingCategories: "Error loading categories",
        noActiveProductsFound: "No active products found for this category",
        errorLoadingProducts: "Error loading products",
        ingredientsLoadedSuccess: "Ingredients loaded successfully",
        errorLoadingIngredients: "Error loading ingredients",
        additionalOptions: "Additional options",
        selectOneOption: "Please select one option",
        customizeProduct: "Customize your product",
        includedIngredientsInfo: "Ingredients marked \"Included\" come with the pizza",
        addModeDescription: "Add Mode: add additional ingredients",
        removeModeDescription: "Remove Mode: remove even included ingredients",
        included: "Included",
        free: "Free",
        unknownIngredient: "Unknown ingredient",
        addToCart: "Add to cart",
        add: "Add",
        customize: "Customize",
        customizeIngredients: "Customize ingredients",
        remove: "Remove",
        addSpecialInstructions: "Add special instructions for your order...",
        customizeSalad: "Customize salad",
        customizePasta: "Customize pasta",
        customizeOptions: "Customize options",
        customizeYour: "Customize your",
        chooseOption: "Choose an option",
        selectedOption: "Selected option",
        addParmesanDescription: "Add grated parmesan for even more flavor (1.00 CHF):",
        createCustomPizza: "Create your custom pizza",
        searchIngredient: "Search for an ingredient...",
        pizzaSummary: "Summary of your pizza",
        sizeLabel: "Size",
        noIngredientsSelected: "No ingredients selected",
        chooseSize: "Choose size",
        glutenFree: "Gluten-free",
        deliveryPrice: "Delivery Price",
        noProductsFound: "No products found",
        tryChangeSearchOrCategory: "Try changing your search or the selected category.",
        addSaucesForSalad: "Add sauces to enhance your salad.",
        chooseYourSauces: "Choose your sauces",
        cart: "Cart",
        generalInfo: "General Information",
        noProductInCart: "No products added to cart at the moment",
        availableIn: "Available in",
        size: "size",
        choose: "Choose",
        orderInstructions: "Order Instructions",
        selectOrderType: "Select order type",
        whenOrder: "When would you like your order?",
        whatToPayAttention: "What should we pay attention to?",
        orderNotes: "Order notes",
        requestUtensils: "Request utensils",
        utensilsQuantity: "Utensils quantity",
        useCustomerInfo: "Use customer information",
        cookingType: {
            normal: "Normal",
            rare: "Rare",
            medium: "Medium",
            wellDone: "Well Done",
        },
        schedule: {
            morningOpening: "Morning Opening",
            lunchBreak: "Lunch Break",
            afternoonOpening: "Afternoon Opening",
        },
        customerInfo: "Customer Information",
        registeredCustomerSelected: "Registered customer selected",
        deselect: "Deselect",
        firstName: "First Name",
        firstNamePlaceholder: "Customer first name",
        lastName: "Last Name",
        lastNamePlaceholder: "Customer last name",
        phone: "Phone",
        phonePlaceholder: "Phone number",
        email: "E-mail",
        emailPlaceholder: "Customer e-mail",
        invalidEmail: "Please enter a valid e-mail address",
        orderType: "Order Type",
        orderTypeDineIn: "Dine-in",
        orderTypeClickCollect: "Takeaway",
        orderTypeDelivery: "Delivery",
        clientType: "Client Type",
        clientTypeCustomer: "Client",
        clientTypeOrganisation: "Organization",
        company: "Company",
        companyPlaceholder: "Company name",
        department: "Department",
        departmentPlaceholder: "Department",
        pickupTime: "Pickup Time",
        asSoonAsPossible: "As soon as possible",
        restaurantClosed: "(Restaurant closed)",
        readyInMinutes: "Ready in 15-20 minutes",
        scheduledDateTime: "Desired date and time",
        scheduleForLater: "Schedule for later",
        pickupDate: "Pickup Date",
        selectDate: "Select a date",
        pickupTimeHour: "Pickup time",
        selectTime: "Select a time",
        noTimeAvailableToday: "No time available today. Please select tomorrow.",
        deliveryAddress: "Delivery Address",
        savedAddresses: "Saved addresses",
        newAddress: "New address",
        postalCode: "Postal Code (ZIP)",
        postalCodePlaceholder: "Postal code",
        locality: "Locality",
        localityPlaceholder: "Locality",
        street: "Street",
        streetPlaceholder: "Street name",
        streetNumber: "Street Number",
        streetNumberPlaceholder: "Street number",
        order: "Order",
        items: "item(s)",
        emptyCart: "Empty cart",
        addItemsToStart: "Add items to get started",
        summary: "Summary",
        promoCode: "Promo Code",
        enterPromoCode: "Enter your promo code",
        apply: "Apply",
        couponRemoved: "Coupon removed",
        minimumOrderAmount: "Minimum order amount:",
        supplementApplied: "(supplement of {amount} CHF applied)",
        disableMinOrder: "Disable minimum amount",
        enableMinOrder: "Re-enable minimum amount",
        discountType: "Discount Type",
        percentage: "Percentage (%)",
        fixedAmount: "Fixed Amount (CHF)",
        discount: "Discount",
        discountPercentage: "Discount (%)",
        discountFixed: "Discount (CHF)",
        miscellaneous: "Miscellaneous (CHF)",
        miscellaneousLabel: "Miscellaneous",
        slice: "Slice:",
        yes: "Yes",
        no: "No",
        note: "Note",
        notePlaceholder: "Enter your note",
        subtotal: "Subtotal",
        discountLabel: "Discount",
        coupon: "Coupon",
        customized: "Customized:",
        removed: "Removed:",
        options: "Options:",
        supplements: "Supplements:",
        paymentMethod: "Payment Method",
        cashPayment: "Cash payment",
        cardPayment: "Card payment",
        minOrderSupplement: "Minimum order supplement",
        vat: "VAT ({rate}%)",
        total: "Total",
        validateOrder: "Validate Order",
        processing: "Processing...",
        orderCreatedSuccess: "Order created successfully!",
        fillAllFields: "Please fill in all fields!",
        restaurantInfoMissing: "Restaurant information missing",
        invalidPromoCode: "Invalid promo code",
        orderCreationError: "Error creating order",
        today: "Today",
        tomorrow: "Tomorrow",
    },
    dashboard: {
        greeting: "Hello",
        whatHappeningToday: "Here's what's happening in your restaurants today",
        whatHappeningTodaySingle: "Here's what's happening in your restaurant today",
        salesThisWeek: "SALES THIS WEEK",
        salesThisWeekByRestaurant: "Current week sales by restaurant",
        salesThisWeekLabel: "Sales this week",
        vsPreviousWeek: "vs previous week:",
        previousWeek: "Previous week",
        thisWeek: "This week",
        thisMonth: "This month",
        thisYear: "This year",
        select: "Select",
        noDataAvailable: "No data available for the chart",
        salesReportThisWeek: "SALES REPORT THIS WEEK",
        salesReportThisMonth: "SALES REPORT THIS MONTH",
        salesReportThisYear: "SALES REPORT THIS YEAR",
        salesReportAllPeriods: "SALES REPORT ALL PERIODS",
        salesReportPreviousWeek: "SALES REPORT PREVIOUS WEEK",
    },
    pages: {
        editCustomer: "Edit Customer",
        addFranchise: "Add Franchise",
        updateFranchise: "Update Franchise",
        addProduct: "Add Product",
        updateProduct: "Update Product",
        orderDetails: "Order Details",
        openingHours: "Opening Hours",
        paymentMethods: "Payment Methods",
        generalInfo: "General Information",
        addDeliveryZone: "Add Delivery Zone",
        updateDeliveryZone: "Update Delivery Zone",
        customerList: "Customer List",
        addCustomer: "Add Customer",
        customerDetails: "Customer Details",
        ingredientList: "Ingredient List",
        ingredientTypeList: "Ingredient Types List",
        addIngredient: "Add Ingredient",
        updateIngredient: "Update Ingredient",
        timeSlotList: "Time Slot List",
        addUser: "Add User",
        updateUserInfo: "Update My Information",
        userList: "User List",
        addCategory: "Add Category",
        updateCategory: "Update Category",
        categoryList: "Category List",
        productList: "Product List",
        createCoupon: "Create Coupon",
        couponDetails: "Coupon Details",
        couponList: "Coupon List",
        franchises: "Franchises",
        addProgram: "Add Program",
        updateProgram: "Update Program",
        referralLoyalty: "Referral & Loyalty",
        deliveryZoneList: "Delivery Zones",
        postalCodes: "Postal Codes",
        notificationList: "Notification List",
        sendNotification: "Send Notification",
        notificationDetails: "Notification Details",
        campaignList: "Campaign List",
        addCampaign: "Add Campaign",
        campaignDetails: "Campaign Details",
        restaurantList: "Restaurant List",
        addRestaurant: "Add Restaurant",
        updateRestaurant: "Update",
        ingredientBaseList: "Base Ingredient List",
        transactionDetails: "Transaction Details",
        orders: "Orders",
        transactions: "Transactions",
        configureOpeningHours: "Configure Opening Hours",
        configureOpeningHoursSubtitle: "Define the opening days and hours of your restaurant",
        saveOpeningHours: "Save hours",
        optionalBreak: "Break (optional)",
        openingDays: "Opening days",
        open: "Open",
        partialOpen: "Partially open",
        detailedHours: "Detailed hours",
        opening: "Opening",
        start: "Start",
        end: "End",
        break: "Break",
        breakStart: "Break start",
        breakEnd: "Break end",
        addHours: "Add hours",
        addBreak: "Add a break",
        removeHours: "Remove hours",
        removeBreak: "Remove break",
        dayStatus: "Day status",
        descriptionForDay: "Description for {dayLabel}",
        daysOfWeek: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
        },
        resetPassword: "Reset Password",
        emailConfirmation: "E-mail Confirmation",
        forgotPassword: "Forgot Password",
        register: "Register",
        addTimeSlot: "Add Time Slot",
        updateTimeSlot: "Update Time Slot",
        thisWeek: "This Week",
        thisMonth: "This Month",
        thisYear: "This year",
        addTimeRange: "Add time range",
        timeRange: "Time range",
        deliverySlotConfig: "Delivery slot configuration",
        active: "Active",
        inactive: "Inactive",
        selectRestaurant: "Select a restaurant",
        allRestaurants: "All restaurants",
        testConnection: "Test connection",
        selected: "Selected",
        selectDayToConfigureHours: "Click on an open day to configure its detailed hours",
        configureTimeRangesForDay: "Configure the time ranges for this day",
        noTimeRanges: "No time ranges configured",
        restaurantClosures: "Restaurant Closures",
    },
    customer: {
        averageBasket: "Average basket",
        orderChannelsBreakdown: "Order channels breakdown",
        customerSpecification: "CUSTOMER SPECIFICATION",
        registeredAddressesList: "List of registered addresses",
        remark: "Remark",
        noRegisteredAddresses: "No registered addresses.",
        orderAnalysis: "Analysis during orders",
        specificAttentionPoints: "Specific attention points",
        enterAttentionPoints: "Enter attention points...",
        orderTypesHistory: "Order types history",
        cutleryRequestDuringOrders: "Cutlery request during orders",
        clientPaymentHabits: "Client payment habits",
        totalOrdersNumber: "Total number of orders",
        orderHistoryTable: "Order history table",
        orderHistory: "Order history",
        primarilyOrdersType: "The client primarily places orders of type \"{type}\" ({count}/{total}).",
        varietyOrderTypes: "The client presents a variety of order types. Dominant type: \"{type}\" ({count}/{total}).",
        alwaysRequestsCutlery: "The client systematically requests cutlery with their orders.",
        neverRequestsCutlery: "The client never requests cutlery.",
        majorityRequestsCutlery: "The client requests cutlery in the majority of cases.",
        rarelyRequestsCutlery: "The client rarely requests cutlery.",
        requestsCutleryAmount: "The client requests {amount} piece(s) of cutlery for their orders.",
        exclusivelyUsesPaymentMethod: "The client exclusively uses the payment method \"{method}\".",
    },
    posClient: {
        title: "POS Client",
        description: "This client will be used by default for orders placed on the POS if no customer is selected.",
        add: "Add POS Client",
        edit: "Edit POS Client",
        delete: "Delete POS Client",
        confirmDelete: "Are you sure you want to delete this POS client?",
        saved: "POS Client saved successfully",
        deleted: "POS Client deleted successfully",
        notFound: "POS Client not found",
        firstName: "First Name",
        lastName: "Last Name",
        email: "E-mail (optional)",
        phone: "Phone",
        civility: "Civility",
    },
    closures: {
        title: "Special Closures",
        addClosure: "Add Closure",
        editClosure: "Edit Closure",
        reason: "Reason",
        startDate: "Start Date",
        endDate: "End Date",
        isRecurring: "Recurring (Yearly)",
        recurringHelp: "If checked, the closure will repeat every year on the same dates.",
        confirmDelete: "Are you sure you want to delete this closure?",
        totalClosure: "Total Closure",
        restaurantSelection: "Restaurant Selection",
        franchiseSelection: "Franchise Selection",
        allRestaurants: "All Restaurants",
        noReason: "No reason specified",
    },
    loyalty: {
        totalReferralsInRange: "Total referrals in this period",
        reportTitle: "Loyalty Points Log",
        reportCustomer: "CUSTOMER",
        reportAction: "ACTION",
        reportPoints: "POINTS",
        reportBalance: "BALANCE",
        reportDate: "Date",
        reportLastActivity: "Last activity",
        earn: "Earned",
        spend: "Spent",
        reverse: "Reversed",
        expired: "Expired",
        adjustPoints: "Adjust points",
        reverseTransaction: "Cancel transaction",
        reverseSuccess: "Transaction cancelled successfully",
        adjustSuccess: "Points adjusted successfully",
        reason: "Reason",
        amount: "Amount",
        confirmReverse: "Are you sure you want to cancel this transaction?",
        confirmAdjust: "Are you sure you want to adjust this customer's points?",
        referralReport: "Referral Report",
        topReferrers: "Top Referrers",
        referrer: "Referrer",
        referee: "Referee",
        referralDate: "Referral Date",
        pointsEarned: "Points Earned",
        rewardStatus: "Reward Status",
        rewarded: "Rewarded",
        pending: "Pending",
        searchReferral: "Search for referrer or referee...",
        referralDetails: "Referral Details",
        noReferrals: "No referrals found for this period.",
        totalReferrals: "Total Referrals",
        totalPoints: "Total Points"
    },
};
